/*
  assets/hrc-diagnostic-report.js
  Renderiza el informe. CORRECCIONES DE ESTA AUDITORIA: P0-3 barras reales
  (se confirma la formula, se blinda con parseFloat/fallback), P0-5
  fortalezas empatadas, P0-5 prioridades conectadas con explicacion, P0-6
  texto de contraste segun audiencia, P1-13 tarjetas + jerarquia visual,
  P1-14 explicacion en lenguaje llano antes del nombre tecnico del patron,
  P1-15 resumen de contexto, P2-20 nota de rol del staff.
*/
(function () {
  'use strict';

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }

  var LEVEL_LABELS = { starting_point: 'Punto de partida', developing: 'En desarrollo', functional: 'Nivel funcional', advanced: 'Nivel avanzado', consolidated: 'Nivel consolidado' };
  var LAYER_LABELS = { knowledge: 'Conocimiento', application: 'Aplicación', consistency: 'Consistencia', demand: 'Bajo exigencia', review: 'Revisión' };

  function renderBars(container, areaScores) {
    container.innerHTML = '';
    areaScores.forEach(function (a) {
      var pct = typeof a.score100 === 'number' && !isNaN(a.score100) ? a.score100 : Math.round(((a.score - 1) / 4) * 100);
      pct = Math.max(0, Math.min(100, pct));
      var row = el('div', 'hrc-d-bar');
      row.appendChild(el('span', 'hrc-d-bar__label', a.label));
      var track = el('div', 'hrc-d-bar__track');
      track.setAttribute('role', 'progressbar');
      track.setAttribute('aria-valuemin', '0');
      track.setAttribute('aria-valuemax', '100');
      track.setAttribute('aria-valuenow', String(pct));
      track.setAttribute('aria-label', a.label);
      var fill = el('div', 'hrc-d-bar__fill');
      fill.style.width = pct + '%';
      track.appendChild(fill);
      row.appendChild(track);
      row.appendChild(el('span', 'hrc-d-bar__value', a.score.toFixed(1) + '/5'));
      container.appendChild(row);
    });
  }

  function renderAdvice(container, advice) {
    container.innerHTML = '';
    advice.forEach(function (a) {
      var card = el('div', 'hrc-d-advice-card');
      card.appendChild(el('h4', null, a.areaLabel));
      card.appendChild(el('p', null, a.advice));
      if (a.refinement) card.appendChild(el('span', 'hrc-d-advice-card__tag', 'Refinamiento'));
      container.appendChild(card);
    });
  }

  function renderActions(container, actions) {
    container.innerHTML = '';
    actions.forEach(function (a, i) {
      var card = el('div', 'hrc-d-action-card');
      card.appendChild(el('span', 'hrc-d-action-card__num', String(i + 1)));
      var body = el('div');
      body.appendChild(el('span', 'hrc-d-action-card__area', a.areaLabel));
      body.appendChild(el('p', null, a.action));
      card.appendChild(body);
      container.appendChild(card);
    });
  }

  function renderAlert(container, alert) {
    container.innerHTML = '';
    if (!alert || !alert.active) { container.hidden = true; return; }
    container.hidden = false;
    var box = el('div', 'hrc-d-alert');
    box.setAttribute('role', 'note');
    box.appendChild(el('h4', null, 'Un aviso importante'));
    box.appendChild(el('p', null, 'Tus respuestas indican una posible molestia, fatiga o limitación física que conviene priorizar. Este diagnóstico es orientativo: no sustituye la valoración de tu entrenador, fisioterapeuta o médico.'));
    box.appendChild(el('p', null, 'Por eso, en este informe no te recomendamos ningún plan de preparación física intensa como opción principal.'));
    container.appendChild(box);
  }

  function productCard(rec) {
    if (!rec) return null;
    var card = el('a', 'hrc-d-product');
    if (rec.klaviyoFormId) {
      card.removeAttribute('href');
      card.setAttribute('data-hrc-klaviyo-form-id', rec.klaviyoFormId);
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.href = '#';
    } else if (rec.availabilityStatus === 'upcoming' && rec.waitlistUrl) {
      card.href = rec.waitlistUrl;
    } else {
      card.href = rec.url;
    }
    card.setAttribute('data-hrc-analytics', 'hrc_diagnostic_product_clicked');
    card.setAttribute('data-hrc-diagnostic-product-id', rec.id);
    if (rec.image) { var img = el('img'); img.src = rec.image; img.alt = rec.title; img.loading = 'lazy'; card.appendChild(img); }
    var body = el('div', 'hrc-d-product__body');
    var slotLabel = { free: 'RECURSO GRATUITO', main: 'RECOMENDACIÓN PRINCIPAL', complement: 'COMPLEMENTO', upcoming: 'PRÓXIMAMENTE' }[rec.slot] || '';
    body.appendChild(el('span', 'hrc-d-product__slot', slotLabel));
    body.appendChild(el('h4', null, rec.title));
    body.appendChild(el('p', 'hrc-d-product__reason', rec.reason));
    if (rec.availabilityStatus === 'upcoming') {
      body.appendChild(el('span', 'hrc-d-product__cta', (rec.waitlistCta || 'Avísame cuando esté disponible') + ' →'));
    } else if (rec.isFree) {
      body.appendChild(el('span', 'hrc-d-product__cta', 'Acceder gratis →'));
    } else {
      body.appendChild(el('span', 'hrc-d-product__cta', 'Ver →'));
    }
    card.appendChild(body);
    return card;
  }

  function renderRecommendations(container, recs) {
    container.innerHTML = '';
    if (!recs.hasMatch) {
      // Auditoria (2a ronda, punto 6): un catalogo vacio (fallo tecnico de
      // carga) NO es lo mismo que un catalogo cargado sin ningun candidato
      // que supere el umbral. Mostrar el mismo mensaje generico en ambos
      // casos induciria a pensar que "no existe ningun recurso compatible"
      // cuando en realidad el catalogo pudo no haber cargado a tiempo.
      if (recs.catalogEmpty) {
        console.error('[HRC Diagnostico] El catálogo llegó vacío al motor de recomendaciones (catalogSize=0). No se puede afirmar que no existan recursos compatibles.');
        container.appendChild(el('p', 'hrc-d-rec-empty', 'No hemos podido cargar los recursos recomendados en este momento. Aplica las acciones prácticas de este informe mientras tanto; puedes repetir el diagnóstico más tarde para ver tu ruta recomendada.'));
      } else {
        container.appendChild(el('p', 'hrc-d-rec-empty', 'Todavía no tenemos un recurso que encaje con suficiente precisión en tu situación actual. Aplica las acciones prácticas de este informe: son el paso más eficaz ahora mismo.'));
      }
      return;
    }
    ['free', 'main', 'complement', 'upcoming'].forEach(function (slot) {
      var card = productCard(recs[slot]);
      if (card) container.appendChild(card);
    });
  }

  function renderStrengths(container, strongestAreas) {
    container.innerHTML = '';
    if (!strongestAreas || !strongestAreas.length) return;
    container.textContent = strongestAreas.map(function (a) { return a.label; }).join(' y ');
  }

  function contextSummaryLine(context, options, audience) {
    if (!context) return '';
    var parts = [];
    var fieldOrder = audience === 'coach' ? ['role', 'context', 'moment'] : ['position', 'levelContext', 'moment'];
    fieldOrder.forEach(function (key) {
      var value = context[key];
      if (!value || !options || !options[key]) return;
      var match = options[key].filter(function (o) { return o.value === value; })[0];
      if (match) parts.push(match.label);
    });
    var line1 = parts.join(' · ');
    var goalOptions = options && options.goal;
    var goalMatch = goalOptions && context.goal ? goalOptions.filter(function (o) { return o.value === context.goal; })[0] : null;
    var line2 = goalMatch ? ('Objetivo: ' + goalMatch.label) : '';
    return { line1: line1, line2: line2 };
  }

  function render(root, result, recommendations, state, extras) {
    extras = extras || {};
    var audience = state.audience;

    root.querySelector('[data-hrc-d-report-level]').textContent = 'Nivel general: ' + (LEVEL_LABELS[result.generalLevel.key] || result.generalLevel.label);
    root.querySelector('[data-hrc-d-report-score]').textContent = result.generalScore.toFixed(1) + ' / 5';
    renderBars(root.querySelector('[data-hrc-d-bars]'), result.areaScores);

    renderStrengths(root.querySelector('[data-hrc-d-strength]'), result.strongestAreas);

    root.querySelector('[data-hrc-d-priority-1]').textContent = result.priority1.label;
    var p2El = root.querySelector('[data-hrc-d-priority-2]');
    var p2Wrap = root.querySelector('[data-hrc-d-priority-2-wrap]');
    var connectedNote = root.querySelector('[data-hrc-d-connected-note]');
    if (result.priority2) {
      p2Wrap.hidden = false;
      p2El.textContent = result.priority2.label;
      if (result.connectedPriorities && connectedNote) {
        connectedNote.hidden = false;
        connectedNote.textContent = '"' + result.priority1.label + '" y "' + result.priority2.label + '" están conectadas: mejorar una suele facilitar la otra, así que puedes trabajarlas juntas.';
      } else if (connectedNote) {
        connectedNote.hidden = true;
      }
    } else {
      p2Wrap.hidden = true;
      if (connectedNote) connectedNote.hidden = true;
    }

    // P1-14: frase comprensible primero, nombre tecnico del patron despues, pequeno.
    var bottleneckMain = root.querySelector('[data-hrc-d-bottleneck-main]');
    var bottleneckTag = root.querySelector('[data-hrc-d-bottleneck-tag]');
    if (extras.bottleneckExplanation) {
      bottleneckMain.textContent = extras.bottleneckExplanation;
    } else {
      bottleneckMain.textContent = result.bottleneck.type === 'clear'
        ? 'Tu patrón muestra un punto de apoyo claro para seguir progresando.'
        : 'Tu patrón es combinado, sin un único punto de apoyo claro.';
    }
    bottleneckTag.textContent = 'Patrón HRC detectado: ' + (LAYER_LABELS[result.bottleneck.layer] || result.bottleneck.layer).toLowerCase() + '.';

    // P1-15: resumen de contexto.
    var contextWrap = root.querySelector('[data-hrc-d-context-summary]');
    if (contextWrap) {
      var summary = contextSummaryLine(state.context, extras.contextOptions, audience);
      contextWrap.innerHTML = '';
      if (summary && summary.line1) contextWrap.appendChild(el('p', 'hrc-d-context-summary__line1', summary.line1));
      if (summary && summary.line2) contextWrap.appendChild(el('p', 'hrc-d-context-summary__line2', summary.line2));
    }

    // P2-20: nota de rol (solo entrenadores con rol distinto de primer entrenador).
    var roleNoteEl = root.querySelector('[data-hrc-d-role-note]');
    if (roleNoteEl) {
      if (extras.roleNote) { roleNoteEl.hidden = false; roleNoteEl.textContent = extras.roleNote; }
      else { roleNoteEl.hidden = true; }
    }

    renderAdvice(root.querySelector('[data-hrc-d-advice]'), result.advice);
    renderActions(root.querySelector('[data-hrc-d-actions]'), result.actions);
    renderAlert(root.querySelector('[data-hrc-d-alert]'), result.alert);
    renderRecommendations(root.querySelector('[data-hrc-d-recommendations]'), recommendations);

    // P0-6: texto de contraste segun audiencia.
    var contrastEl = root.querySelector('[data-hrc-d-contrast-text]');
    if (contrastEl && extras.contrastText) contrastEl.textContent = extras.contrastText;
    // P0-C (2a ronda): ya no se rellenan campos de impresion en esta pantalla
    // -- el PDF es ahora un documento independiente (hrc-diagnostic-print.js),
    // no una vista oculta de esta misma pagina.
  }

  window.HRC_DIAGNOSTIC_REPORT = { render: render };
})();
